import { Result } from '@/types/base';
import { AgGridRequest, AgencyModel } from '@/types/models';
import { Department } from '@/types/sale';
import { notification } from 'antd';
import { ResponseError } from 'umi-request';
import CrudRequest from '../CrudRequest';
import request, { baseErrorHandler } from '../request';

class Agency extends CrudRequest<AgencyModel> {
    public async getAgencySoldPolicies(params: AgGridRequest, id: string, department: Department) {
        return request(`/policy/${department}/ag`, {
            method: 'POST',
            data: {
                ...params,
                agencyId: id,
            },
        });
    }

    public async checkBalance(currencyType: string): Promise<Result<number>> {
        return request(`/${this.entity}/balance/${currencyType}`);
    }

    public async getDuplicateStartBrokerStatus(agencyId: string): Promise<Result<number>> {
        return request(`/${this.entity}/getduplicatestarbrokerstatus/${agencyId}`, {
            errorHandler: (e: ResponseError | any) => {
                const errorStatusCode: number = e.response?.status;

                if (errorStatusCode === 503) {
                    notification.error({
                        message: <div>Error ne komunikimin me Starbroker. Statusi per duplikaten nuk mund te merrej!</div>,
                    });
                    throw e;
                }

                baseErrorHandler(e);
            },
        });
    }

    public async setDuplicateStartBrokerStatus(agencyId: string, status: boolean): Promise<Result<number>> {
        return request(`/${this.entity}/setduplicatestarbrokerstatus/${agencyId}`, {
            method: 'POST',
            data: {
                status,
            },
            errorHandler: (e: ResponseError | any) => {
                const errorStatusCode: number = e.response?.status;

                if (errorStatusCode === 503) {
                    notification.error({
                        message: <div>Error ne komunikimin me Starbroker. Statusi per duplikaten nuk mund perditesohej!</div>,
                    });
                    throw e;
                }

                baseErrorHandler(e);
            },
        });
    }

    public async setSpecificConfiguration(agencyId: string, data: any) {
        return request(`/${this.entity}/configuration/${agencyId}`, {
            method: 'POST',
            data,
        });
    }
    
}

export default new Agency('agency');
